module.exports = __webpack_public_path__ + "img/b2b2de3.jpg";